<template>
  <div @click.stop="operation()" class="d-flex flex-column justify-content-end">
    <span v-show="false"> {{ reactivity }}</span>

    <div v-if="loading" class="product-counter text-center py-1">
      <half-circle-spinner
        :animation-duration="1000"
        :size="20"
        color="#6200ea"
        class="mx-auto"
        style="margin-top: 2px"
      />
    </div>
    <div class="d-flex product-counter align-center" v-else>
      <span v-show="false">{{ reactivity }}</span>
      <div v-if="item.stock === item.amount">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="pointer" style="opacity: 0.4" v-bind="attrs" v-on="on">
              <v-icon class="shoppurple--text">mdi-plus</v-icon>
            </div>
          </template>
          <span class="fs-xsmall white--text">حداکثر {{ item.stock }} عدد</span>
        </v-tooltip>
      </div>
      <div v-else @click.stop="addToCart(item)" class="pointer">
        <v-icon class="shoppurple--text">mdi-plus</v-icon>
      </div>
      <div v-if="item.amount == 0" class="text-center py-1 w-100">
        <half-circle-spinner
          :animation-duration="1000"
          :size="20"
          color="#6200ea"
          class="mx-auto"
          style="margin-top: 2px"
        />
      </div>
      <span
        v-else
        class="fs-medium count shoppurple--text text-center font-weight-light"
      >
        {{ item.amount }}
      </span>
      <div
        @click.stop="reduceItem(item)"
        v-if="item.amount > 1"
        class="pointer"
      >
        <v-icon class="shoppurple--text">mdi-minus</v-icon>
      </div>
      <div @click.stop="removeItem(item, index)" v-else class="pt-1 pointer">
        <v-icon
          class="shoppurple--text fs-xxlarge"
          :style="
            usage == 'menu'
              ? 'transform: translateX(-3px)'
              : 'transform: translateX(1px)'
          "
        >
          mdi-delete-outline
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { HalfCircleSpinner } from "epic-spinners";
import Axios from "axios";
export default {
  components: {
    HalfCircleSpinner,
  },
  props: ["item", "index", "usage", "cartId"],
  data() {
    return {
      reactivity: false,
      loading: false,
    };
  },

  mounted() {
    this.cart = localStorage.getItem("cart")
      ? JSON.parse(localStorage.getItem("cart"))
      : [];
  },

  methods: {
    ...mapMutations(["setInCart"]),
    setInStorage() {
      this.setInCart(this.cart);
      localStorage.setItem("cart", JSON.stringify(this.cart));
    },
    addToCart(item) {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/onlineShop/cart/addItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.$store.dispatch("checkExist", {
              id: item.id,
            });
            this.reactivity = !this.reactivity;
            this.toast(res.data.message, "success");
            item.amount = item.amount + 1;
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.toast(err.response.data, "error");
        });
    },
    reduceItem(item) {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/onlineShop/cart/removeItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          this.reactivity = !this.reactivity;
          if (res.status == 200) {
            this.$store.dispatch("checkExist", {
              id: item.id,
            });
            let products1 = res.data.items;
            if (!products1.length) {
              localStorage.setItem("cart", []);
              this.clearCart();
            }
            this.toast(res.data.message, "success");
            if (item.amount != 1) {
              item.amount--;
            }
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.toast(err.response.data, "error");
        });
    },
    clearCart() {
      Axios.post(
        this.baseUrl + "/onlineShop/cart/clear/" + this.cartId,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.reactivity = !this.reactivity;

            this.toast(res.data.message, "success");
            localStorage.setItem("cart", []);
            this.selectedProducts = [];
            this.$emit("chance");
            // setTimeout(() => {
            //   this.$router.push("/main");
            // }, 500);
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.toast.error(err.response.data);
        });
    },
    removeItem(item, index) {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/onlineShop/cart/removeItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          this.reactivity = !this.reactivity;
          if (res.status == 200) {
            let products1 = res.data.items;
            if (!products1.length) {
              localStorage.setItem("cart", []);
              this.clearCart();
            }
            this.toast(res.data.message, "success");
            if (item.amount != 1) {
              item.amount--;
            } else {
              item.amount = 0;
              this.$emit("send-amount", item.amount);
            }
          }
        })
        .catch((err) => {
       
          this.loading = false;
          this.toast(err.response.data, "error");
        });
    },
    operation() {},
  },
  computed: {
    ...mapGetters(["cartItems"]),
  },

  watch: {
    cartItems(val) {
      this.cart = val;
    },
  },
};
</script>

<style lang="scss">
.product-counter {
  background-color: #fff;
  border: 1px solid #6200ea;
  border-radius: 5px;
  height: 32px;
  padding: 0 5px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .count {
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 5px 15px;
  }
}
</style>
